// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": require("gatsby-module-loader?name=component---src-pages-404-tsx!/opt/render/project/src/src/pages/404.tsx"),
  "component---src-pages-index-tsx": require("gatsby-module-loader?name=component---src-pages-index-tsx!/opt/render/project/src/src/pages/index.tsx")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/render/project/src/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/render/project/src/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/render/project/src/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/render/project/src/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-tsx!/opt/render/project/src/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js